import { useContext, useMemo } from "react";
import clsx from "clsx";
import { ButtonBar } from "@k8slens/lds";

import { useGetBusinessSubscriptions } from "src/hooks/useGetBusinessSubscriptions";
import { isAppIQPlan } from "src/services/plans";

import TrackedAnchorButton from "src/components/TrackedAnchor/TrackedAnchorButton";
import { BusinessContext } from "src/components/Business/Base";

import AppIQSubscriptionTable from "./AppIQSubscriptionTable";

import styles from "./page.module.css";

const contactSalesLabel = "Contact Sales";
const contactSalesUrl = "https://k8slens.dev/purchase-request";

const AppIQ = () => {
  const { businessId, business } = useContext(BusinessContext);
  const { businessSubscriptions, loading: loadingBusinessSubscriptions } = useGetBusinessSubscriptions(businessId);

  const appIQSubscriptions = useMemo(
    () => businessSubscriptions.filter((s) => isAppIQPlan(s.planCode) && s.state !== "expired"),
    [businessSubscriptions],
  );

  return (
    <>
      <header className={styles.appiq}>
        <h2 className={clsx("lds-h2-caps", styles.heading)}>Lens AppIQ</h2>
        <p>Manage your Lens AppIQ subscription here.</p>
      </header>
      <section className={styles.appiq}>
        <h3 className={clsx("lds-h3", styles.tableTitle)}>Subscriptions</h3>
        <AppIQSubscriptionTable
          businessSubscriptions={appIQSubscriptions}
          loading={loadingBusinessSubscriptions}
          business={business}
        />
        <ButtonBar type="grid" className={styles.buttonBar}>
          <TrackedAnchorButton label={contactSalesLabel} href={contactSalesUrl} discreet primary />
        </ButtonBar>
      </section>
    </>
  );
};

export default AppIQ;
